import { TResultTanquerayProps } from "../type";
import { useAppStore, useCmsStore } from "@/components/AppHooks";
import { DdpCta } from "@/components/shared/DdpCta";
import { DdpImage } from "@/components/shared/DdpImage";
import { useEffect, useState } from "react";
import { getCocktailInfo, interaction } from "@/shared/utils";
import { TDdpMedia } from "@/shared/types";

export function SmallCardList(props: TResultTanquerayProps) {
    const {
        dreamerCocktailPreview,
        ctaLearnMoreDreamerCocktail
    } = props
    const { secondResults,results } = useAppStore()!
    const { locale, storeConfig } = useCmsStore()!
    const [showCocktails, setShowCocktails] = useState<Array<{
        belowImage: TDdpMedia,
        previewTitle: string,
        desc: string,
        id: string
    }>>([])
    useEffect(() => {
        if (!secondResults) return;
        const cocktailIds = secondResults?.cocktailRecommendations.slice(1).map((item) => item.cocktailId)
        getCocktailInfo(cocktailIds, 'secondCocktailList').then((cocktails) => {
            const _cocktails = cocktails.map((cocktailInfo) => {
                const dreamerCocktailPreviewItem = dreamerCocktailPreview.find((item) => item.iDDreamerCocktail === cocktailInfo.id)!
                return {
                    belowImage: dreamerCocktailPreviewItem.belowImage[0],
                    previewTitle: dreamerCocktailPreviewItem.previewTitle,
                    desc: cocktailInfo.cocktailDescription,
                    id: cocktailInfo.id
                }
            })
            setShowCocktails(_cocktails)
        })
    }, [secondResults])
    if (!secondResults) return null
    return (
        <div className='smallCard-list'>
            {
                showCocktails.map((item) => (
                    <div className='card-item' key={item.id}>
                        <div className="cocktai-media-wrapper" >
                            <DdpImage image={item.belowImage} />
                        </div>
                        <div className="cocktail-content-wrapper" >
                            <div className="title">{item.previewTitle}</div>
                            <div className="desc" dangerouslySetInnerHTML={{ __html: item.desc }}></div>
                            <DdpCta className="cta-learn-more link" cta={{
                                show: ctaLearnMoreDreamerCocktail[0].show,
                                text: ctaLearnMoreDreamerCocktail[0].text,
                                url: ctaLearnMoreDreamerCocktail[0].url + '?cocktailId=' + item.id
                            }}
                            onClick={() => {
                                interaction([item.id], `${locale}_${storeConfig.secondSitename?.id}`, results?.consumerId as string, 'Click')
                            }}
                            />
                        </div>
                    </div>
                ))
            }
        </div>

    )
}